<button matIconButton type="button" class="close" mat-dialog-close>
    <mat-icon>close</mat-icon>
</button>
<!--r *ngIf="data.title"  -->
<!-- <ng-container> -->
    <!-- <h4 mat-dialog-title [innerHTML]="data.title">  </h4>    -->
    <!-- <h4 mat-dialog-title>{{data.title}} </h4> -->
<!-- </ng-container> -->

<ng-container>
    <div mat-dialog-content  align="center">
        <!-- <div class="flex-container container-centered" style="text-align: center;"> -->
            <img src="../../../../assets/svg/noroadacces_icon.svg" alt="" width="110" height="110" />
            <p [innerHTML]="data.text"></p>
        <!-- </div> -->
    </div>
</ng-container>
<!-- <div mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close cdkFocusInitial>{{ (data.cancelLabel ? (data.cancelLabel | uppercase): ("trace.close-panel"| translate | uppercase)) }}</button>
    <button mat-stroked-button [mat-dialog-close]="{data}">{{ (data.continueLabel ? (data.continueLabel | uppercase) : "OK") }}</button>
  </div> -->
  <!-- cdkTrapFocus [cdkTrapFocusAutoCapture]="true" -->
<mat-dialog-actions align="center" class="" >
    <div class="button-container">
        <!-- <button mat-flat-button color="primary" [mat-dialog-close]="{data}" cdkFocusInitial>{{ (data.continueLabel ? (data.continueLabel ) : "Ok") }}</button> -->
        <button mat-flat-button mat-dialog-close class="orange-button">Ok</button>
    </div>
     <div >
        &nbsp;
       <!-- <a mat-dialog-close class="close-tip">{{ (data.cancelLabel ? (data.cancelLabel | uppercase): ("general.cancel"| translate )) }}</a>  -->
    </div> 
</mat-dialog-actions>